// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1pqNg","colMaxWidth":"Table_colMaxWidth__1my8z"};